import React, { useState } from 'react';
import { Tabs, Tab, Button, Typography, Card, CardContent, Grid, Box } from '@mui/material';
// import Tab from "@mui/material/Tab";
// import Typography from "@mui/material/Typography";
// import Box from "@mui/material/Box";
import { useNavigate } from 'react-router-dom';
import QuotesTableWrapper from '../QuotesTableWrapper';
import { MixpanelWrapper } from '../MixPanelWrapper';
import TabPanel from '../TabPanel';
import { clearQuoteId, resetStage } from '../../services/features/quoteSlice/quoteSlice';
import { useDispatch } from 'react-redux';
import { StatusNumber } from '../../helper/statusNumber';

/**
 * HomePageQuoteTab component for displaying tabs with quotes and renewals.
 *
 * @param {object} props - Component props.
 * @param {boolean} props.createQuoteButton - Indicates whether a "Create quote" button should be shown.
 * @returns {JSX.Element} - React JSX element representing the quote tab component.
 */
const QuotesTab = (props: any) => {
	let navigate = useNavigate();
	const [value, setValue] = useState(0);

	const dispatch = useDispatch();

	// Handle tab change and track events using Mixpanel
	const handleChange = (
		event: React.ChangeEvent<HTMLInputElement> | React.SyntheticEvent<Element, Event>,
		newValue: number
	) => {
		setValue(newValue);
		if (newValue === 1) {
			MixpanelWrapper.track('Renewals');
		}
	};

	// Function to set accessibility properties for tabs
	function a11yProps(index: number) {
		return {
			id: `quotes-tab-${index}`,
			'aria-controls': `quotes-tabpanel-${index}`,
		};
	}

	// Function for navigating to create quote page and track event using Mixpanel
	const createQuote = () => {
		if (value === 1) {
			MixpanelWrapper.track('Renewals - Create Quote');
		}
		dispatch(clearQuoteId());
		dispatch(resetStage());
		navigate('/create-quote', { state: { createQuote: true } });
	};

	const quoteStatuses = Object.values(StatusNumber).filter(
		(n) => typeof n === 'number' && n !== StatusNumber.QuotePolicyCreated
	) as number[];

	return (
		<Card sx={{ borderRadius: '9px', my: '2em' }}>
			<Grid container py={1}>
				<Grid item xs={true}>
					<Tabs value={value} onChange={handleChange} sx={{ px: 1 }}>
						<Tab label='New business' {...a11yProps(0)} />
						<Tab label='Renewals' {...a11yProps(1)} />
					</Tabs>
				</Grid>
				{props.createQuoteButton != null && (
					<Grid item xs={2}>
						<Button color='primary' variant='contained' onClick={createQuote}>
							Create quote
						</Button>
					</Grid>
				)}
			</Grid>
			<CardContent sx={{ p: 0, pb: '0 !important' }}>
				{/* Display the quotes table */}
				<TabPanel value={value} index={0}>
					<QuotesTableWrapper quoteStatuses={quoteStatuses} />
				</TabPanel>
				{/* Display the renewals table (just static text saying "no renewals" for now) */}
				<TabPanel value={value} index={1}>
					<Box px={3}>
						<Typography variant='subtitle1'>
							You have no upcoming renewals to display
						</Typography>
					</Box>
				</TabPanel>
			</CardContent>
		</Card>
	);
};

export default QuotesTab;
